import React, { FC } from 'react';
import { IconType } from '@app/components/ui/icons/icon.type';

const WidgetFlagFill: FC<IconType> = (props) => {
  const { size, className, customStyle } = props;
  return (
    <div className={className}>
      <svg
        style={customStyle}
        width={size}
        height={size}
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        fill="currentColor"
        stroke="none"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M5 3v18m0-18l10 4-10 4" />
      </svg>
    </div>
  );
};

export default WidgetFlagFill;
